
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-up/promo",
      function () {
        return require("private-next-pages/sign-up/promo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign-up/promo"])
      });
    }
  